import * as React from 'react';
import { render } from 'react-dom';

import PriceChangeSubscription, { IPriceChangeSubscriptionProps } from './components/price_change_subscription/price_change_subscription';

interface IPriceChangeSubscriptionBundle {
  PriceChangeSubscription: typeof PriceChangeSubscription;
}

function loadBundle() {
  return new Promise<IPriceChangeSubscriptionBundle>(
    (resolve, reject) => {
      require.ensure([
        './components/price_change_subscription/price_change_subscription',
      ], () => {
        resolve({
          PriceChangeSubscription: require('./components/price_change_subscription/price_change_subscription').default,
        });
      });
    }
  );
}

function initPriceChangeSubscription() {
  const exports = (window as any);

  exports.renderPriceChangeSubcriptionButton = (element: Element, props: IPriceChangeSubscriptionProps) => {
    loadBundle()
      .then(({ PriceChangeSubscription }) => {
        render(<PriceChangeSubscription {...props} />, element);
      }
    )
  };
}

export default initPriceChangeSubscription;



// WEBPACK FOOTER //
// ./src/bundles/price_change_subscription/index.tsx